import { Platform_Web_getInstanceu4ctcncq1n0 as Platform_Web_getInstance } from './Platform.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_current(_this__u8e3s4) {
  return Platform_Web_getInstance();
}
function get_usesTouchscreen(_this__u8e3s4) {
  return window.matchMedia('(pointer: coarse)').matches;
}
//region block: exports
export {
  get_current as get_current2r182tjucmm5v,
  get_usesTouchscreen as get_usesTouchscreengqckifr7xvdp,
};
//endregion

//# sourceMappingURL=Platform.js.mjs.map
